import { Box } from '@chakra-ui/react'
import React from 'react'
import SubTitle from './SubTitle'
import { awardsIcon, publicationsIcon, seminarIcon } from './Icons'
import OrderedListComp from './OrderedListComp'
import NotAvailable from './NotAvailable'
import CardView from './CardView'

const Achievements = ({ Achievements }) => {

    return (
        <>
            <Box>
                <SubTitle title="Awards" titleIcon={awardsIcon} />
                <OrderedListComp array={Achievements?.Awards ? Achievements?.Awards : []} />
            </Box>
            <Box>
                <SubTitle title="Seminars" titleIcon={seminarIcon} />
                <OrderedListComp array={Achievements?.Seminars ? Achievements?.Seminars : []} />
            </Box>
            <Box>
                <SubTitle title="Publications" titleIcon={publicationsIcon} />
                <OrderedListComp array={Achievements?.Publications ? Achievements?.Publications : []} />
            </Box>
        </>

        // <>
        //     <Box>
        //         <SubTitle title="Awards" titleIcon={awardsIcon} />
        //         {
        //             Achievements?.Awards.length === 0 ? <NotAvailable /> :
        //                 Achievements?.Awards.map((obj, index) =>
        //                     <CardView key={index} cardObj={obj} />)
        //         }
        //     </Box>
        //     <Box>
        //         <SubTitle title="Seminars" titleIcon={seminarIcon} />
        //         {
        //             Achievements?.Seminars.length === 0 ? <NotAvailable /> :
        //                 Achievements?.Seminars.map((obj, index) =>
        //                     <CardView key={index} cardObj={obj} />)
        //         }
        //     </Box>
        //     <Box>
        //         <SubTitle title="Publications" titleIcon={publicationsIcon} />
        //         {
        //             Achievements?.Publications.length === 0 ? <NotAvailable /> :
        //                 Achievements?.Publications.map((obj, index) =>
        //                     <CardView key={index} cardObj={obj} />)
        //         }
        //     </Box>
        // </>
    )
}

export default Achievements